// src/components/ProfileComponentPrivacyPolicy.js

import { Link } from 'react-router-dom';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';

import './ProfileComponent.scss';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
const ProfileComponentPrivacyPolicy = () => {
    const BackNavIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 30 30"
            fill="none"
        >
            <g clip-path="url(#clip0_77225_1906)">
                <path
                    d="M12.5 27.5L0 15L12.5 2.5L14.7188 4.71875L4.4375 15L14.7188 25.2813L12.5 27.5Z"
                    fill="#2F2B43"
                />
            </g>
            <defs>
                <clipPath id="clip0_77225_1906">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    const url =
        'https://api.ingaged.me/v1/files/asset/cms/development/f3jzqknz3ezo/en-US/VuzQKWqwnx0afIehiwO2ndcT.pdf';

    const getFileExtension = url => {
        const extension = url.split('.').pop();
        return extension;
    };

    const getFileName = url => {
        const fileName = url.split('/').pop();
        return fileName;
    };

    const fileExtension = getFileExtension(url);
    const fileName = getFileName(url);

    const doc = [{ uri: url, fileType: fileExtension, fileName: fileName }];

    return (
        <div>
            <div className="ing-edit-profile-header-main mb-3">
                <Link to={ROUTES.PROFILE}>
                    <BackNavIcon />
                </Link>
                {getText('msg_9db108ba6b7f')}
            </div>
            <DocViewer
                documents={doc}
                pluginRenderers={DocViewerRenderers}
                config={{
                    header: {
                        disableHeader: true,
                        disableFileName: true,
                    },
                }}
            />
        </div>
    );
};

export default ProfileComponentPrivacyPolicy;
